module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-dialogs"
    }
  }, [_c('b-modal', {
    attrs: {
      "id": "modalrules",
      "ok-only": "",
      "ok-title": "Merci",
      "title": "Règles du jeu"
    }
  }, [(_vm.gameMode !== 'boardPlay') ? _c('section', [_c('h4', [_vm._v("Jeu live")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Un premier joueur ouvre le jeu sur son téléphone (ou tous les autres joueurs quittent leurs yeux de l'écran). Ce joueur clique sur le bouton \"Jouer\" caché derrière la carte \"Concept\".\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Sur la carte, il choisit le mot ou l'expression qu'il veut faire deviner.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Pour faire deviner le mot, il dispose de l'ensemble des "), _c('i', [_vm._v("concepts")]), _vm._v(" disponibles sur le plateau de jeu. Le premier concept étatn le concept principal, les autres lignes des concepts secondaires.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Pour ajouter un "), _c('i', [_vm._v("concept")]), _vm._v(" à un concept principal ou secondaire, le joueur clique sur la ligne du concept puis clique sur l'icône du concept qu'il veut ajouter et clique sur le "), _c('font-awesome-icon', {
    attrs: {
      "icon": "plus-circle"
    }
  }), _vm._v(". Pour supprimer un "), _c('i', [_vm._v("concept")]), _vm._v(", il clique sur l'icône du concept qu'il a ajouté et clique sur la "), _c('font-awesome-icon', {
    attrs: {
      "icon": "trash"
    }
  }), _vm._v(".\n      ")], 1), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Lorsque l'un des autres joueurs trouve le mot ou l'expression qu'il fallait deviner, le joueur qui faisait deviner peut réinitialiser le plateau en cliquant sur la carte \"Concept\" et le bouton \"Réinitialiser\".\n      ")]), _vm._v(" "), _c('h4', [_vm._v("Jeu solo / plateau")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Dans ce mode de jeu, vous piochez un mot et vous pouvez alors construire un plateau de jeu avec des icônes associées. L'objectif reste identique : faire deviner des mots aux autres joueurs. Vous pouvez créer autant de plateaux que vous souhaitez en essayant de nouveaux mots à chaque fois.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Puis à votre tour, vous pouvez tenter de découvrir les mots cachés par les plateaux créés par les autres joueurs.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.gameMode === 'boardPlay') ? _c('section', [_c('h4', [_vm._v("Jeu solo / devinez le plateau")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n        Essayez de deviner le plus rapidement possible le mot associé à ce tableau.\n        Vous pouvez proposer autant de mots que vous le souhaitez, à vous d'être le plus rapide.\n      ")])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modalabout",
      "ok-only": "",
      "ok-title": "D'accord",
      "title": "A propos"
    }
  }, [_c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n      Ce jeu s'appuie librement sur le jeu de société "), _c('b', [_vm._v("Concept")]), _vm._v(" que nous vous conseillons.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n      Il n'est absolument pas cautionné par les auteurs originaux du jeu, il s'agit d'un hommage (et d'un petit test aussi). A la moindre demande, l'accès à ce prototype sera retiré.\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010c6a04","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-rules.vue
// module id = SLXI
// module chunks = 1